/*
* Contract Basis - Long Term Lease Fees Requests
* */
import {
    RequestConfigFunction,
} from 'app/types/request.types'

type LongTermLeaseFeesRequests = {
    filterRequest: RequestConfigFunction<Record<string, any>>,
    getAllowedFeeNames: RequestConfigFunction,
    update: RequestConfigFunction<{ id: number }>,
    create: RequestConfigFunction<{ id: number }>,
    get: RequestConfigFunction<{ id: number }>,
    validation: RequestConfigFunction<{ id: number }>,
    restore: RequestConfigFunction<{ id: number }>,
    cancellation: RequestConfigFunction<{ id: number }>,
    archive: RequestConfigFunction<{ id: number }>,
    changeValidity: RequestConfigFunction<{ id: number }>,
}

const longTermLeaseFeesRequests: LongTermLeaseFeesRequests = {
    filterRequest: ({
        params = {},
    } = {}) => {
        return {
            url: 'longtermleasefees/filter-request/all',
            method: 'POST',
            ...params,
        }
    },
    getAllowedFeeNames: () => {
        return {
            url: 'longtermleasefees/feename/feechargeability/allowed',
            method: 'GET',
        }
    },
    update: ({
        id,
    }) => {
        return {
            url: `longtermleasefees/${id}`,
            method: 'PUT',
        }
    },
    create: () => {
        return {
            url: 'longtermleasefees',
            method: 'POST',
        }
    },
    get: ({
        id,
    }) => {
        return {
            url: `longtermleasefees/${id}`,
            method: 'GET',
        }
    },
    validation: ({
        id,
    }) => {
        return {
            url: `longtermleasefees/${id}/status/valid`,
            method: 'PATCH',
        }
    },
    restore: ({
        id,
    }) => {
        return {
            url: `longtermleasefees/${id}/restore`,
            method: 'PATCH',
        }
    },
    cancellation: ({
        id,
    }) => {
        return {
            url: `longtermleasefees/${id}/status/cancelled`,
            method: 'PATCH',
        }
    },
    archive: ({
        id,
    }) => {
        return {
            url: `longtermleasefees/${id}/archive`,
            method: 'PATCH',
        }
    },
    changeValidity: ({
        id,
    }) => {
        return {
            url: `longtermleasefees/${id}/validity`,
            method: 'PATCH',
        }
    },
}

export default longTermLeaseFeesRequests
